module.exports = __webpack_public_path__ + "img/efe0c7a3-9835-4dfb-87e1-575b7d06701a.e2ac5748.jpg";